'use client';

import { cn } from '@core/utils';
import type { HomeGiftProductDto } from '@generated/unauth';

import { GiftListItem } from '@/app/donation/_components/GiftListItem';
import { GIFT_SALE_STATUS } from '@/app/donation/constants';
import { BREAKPOINTS } from '@/constants/breakpoints';
import { useMediaQuery } from '@/hooks/useMediaQuery';

interface RelatedGiftsProps {
  institutionName: string;
  contents: HomeGiftProductDto[];
  totalCount: number;
}

export const RelatedGifts = ({
  institutionName,
  contents,
  totalCount,
}: RelatedGiftsProps) => {
  const isDesktopViewport = useMediaQuery(BREAKPOINTS.DESKTOP, true);

  const slicedContents = contents.slice(0, isDesktopViewport ? 8 : 4);

  if (totalCount < 1) return null;

  return (
    <section className={cn('mb-80 flex flex-col', 'mobile-tablet:mb-40')}>
      <h2
        className={cn(
          'mb-24 px-20 text-center font-800 text-Gray-900 typo-h4',
          'mobile-tablet:whitespace-pre-line mobile-tablet:text-start mobile-tablet:font-600 mobile-tablet:typo-body1',
        )}
      >
        {institutionName}에는{'\n'}
        <span className="mobile-tablet:font-500 mobile-tablet:text-Gray-600 mobile-tablet:typo-body3">
          이런 답례품이 있어요
        </span>
      </h2>
      <ul
        className={cn(
          'grid grid-cols-4 gap-x-20 gap-y-40',
          'mobile-tablet:grid-cols-2 mobile-tablet:gap-x-16 mobile-tablet:gap-y-32 mobile-tablet:px-20',
        )}
      >
        {slicedContents.map((product) => (
          <li key={product.productNumber}>
            <GiftListItem
              productNumber={product.productNumber}
              mainImageUrl={product.mainImageUrl}
              title={product.productName}
              donationAmount={product.requiredDonationAmount}
              reviewRating={product.reviewRating}
              isSoldOut={
                product.productSaleStatus === GIFT_SALE_STATUS.SOLD_OUT
              }
              reviewCount={product.reviewCount}
              isAdult={product.adultYN}
              institution={{
                id: product.institutionId,
                logoUrl: product.institutionLogoUrl,
                name: product.institutionName,
              }}
              isNew={product.newDisplayYN}
            />
          </li>
        ))}
      </ul>
    </section>
  );
};
